import React from 'react';
import { motion } from 'framer-motion';
import { Layers, MessageSquare, MapPin, CheckSquare } from 'lucide-react';
export function ValueSection() {
  const blocks = [{
    icon: <Layers className="w-5 h-5 text-blue-600" data-id="element-285" />,
    title: 'Contexto',
    text: 'Qué se estaba viendo.'
  }, {
    icon: <MessageSquare className="w-5 h-5 text-blue-600" data-id="element-286" />,
    title: 'Conversación',
    text: 'Qué se dijo antes y después.'
  }, {
    icon: <MapPin className="w-5 h-5 text-blue-600" data-id="element-287" />,
    title: 'Ubicación',
    text: 'Dónde ocurrió.'
  }, {
    icon: <CheckSquare className="w-5 h-5 text-blue-600" data-id="element-288" />,
    title: 'Decisión',
    text: 'Qué se resolvió mirando esa foto.'
  }];
  return <section className="py-16 sm:py-24 bg-white" data-id="element-289">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-290">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center text-2xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-[1.1] tracking-tight mb-12 sm:mb-16 max-w-3xl mx-auto" data-id="element-291">
          Una foto sola{' '}
          <span className="text-blue-600" data-id="element-292">no explica una obra.</span>
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 mb-16 sm:mb-20" data-id="element-293">
          {blocks.map((block, index) => <motion.div key={block.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="bg-gray-50 border border-gray-200 rounded-2xl p-5 sm:p-6" data-id="element-294">
              <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center mb-4" data-id="element-295">
                {block.icon}
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1.5" data-id="element-296">
                {block.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-297">
                {block.text}
              </p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center text-xl sm:text-2xl lg:text-3xl font-extrabold text-gray-900 leading-tight tracking-tight max-w-3xl mx-auto" data-id="element-298">
          Cualquiera puede guardar fotos.
          <span className="block text-blue-600 mt-2" data-id="element-299">
            El problema es guardar la historia detrás de ellas.
          </span>
        </motion.p>
      </div>
    </section>;
}